import script from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"

import "./RestoreAccountView.vue?vue&type=style&index=0&id=19b5dd4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b5dd4a"]])

export default __exports__